<template>
  <div class="no-crumbs">
    <h1 class="sr-only">
      Tarvike.com
    </h1>
    <section class="mb-4">
      <div class="md:pt-4 mb-4 md:container">
        <LexasHeroBanner />
      </div>
      <div class="container mb-2 md:mb-4">
        <LexasPageMessage />
      </div>
      <div class="container">
        <LexasTileBanner />
      </div>
      <div class="md:pt-4 pt-2 container">
        <LexasHomePageBanner />
      </div>
    </section>
    <LexasPopularCategories />
    <InstagramFeed />
    <section>
      <ProductTileCarousel
        product-search-query="categories.id:3729"
        carousel-title="Tarjoukset"
        search-key="homePageOffers"
        :hits-per-page="12"
        class="bg-gold-200"
      >
        <HeadingLink to="/category/tarjoukset" button-text="Kaikki tarjoukset">
          <h2 class="beta">
            Tarjoukset
          </h2>
        </HeadingLink>
      </ProductTileCarousel>

      <ProductTileCarousel
        product-search-query="categories.id:7437"
        carousel-title="Laitetarjoukset"
        search-key="MachineOffers"
        :hits-per-page="12"
        class="bg-grey-100"
      />

      <ProductTileCarousel
        product-search-query="categories.id:3728"
        carousel-title="Uutuudet"
        search-key="homePageNewArrivals"
        :hits-per-page="12"
        class="bg-pine-200"
      />
    </section>
    <LexasBrandList />
    <BlogHighlights class="bg-pine-950" />
    <div class="container pb-12 pt-4 max-w-prose">
      <h2 class="gamma mb-6 mt-4">
        Tarvike.com unelmien konekauppa. Tilaa netistä tai vieraile myymälöissämme!
      </h2>
      <p>
        Tarvikekeskus Oy on nyt Tarvike.com! Uuden markkinointinimemme Tarvike.com myötä pyrimme palvelemaan asiakkaitamme entistä paremmin ja laadukkaammin, samalla kunnioittaen Tarvikekeskus Oy:n perintöä.
      </p>
      <p class="my-2">
        Ranuan Tarvikekeskus Oy on perustettu vuonna 1988 <NuxtLink to="/cms/myymalat/ranua">Ranualla</NuxtLink>, josta yrityksen toiminta on laajentunut <NuxtLink to="/cms/myymalat/rovaniemi">Rovaniemelle</NuxtLink>, <NuxtLink to="/cms/myymalat/oulu">Ouluun</NuxtLink> sekä verkkokaupan myötä valtakunnalliseksi.
      </p>
      <p>
        Tarvikekeskus Oy:n kasvutarina ja laadukas palvelu jatkuu ja kehittyy nimen Tarvike.com alla. Yrityksen virallinen nimi on edelleen Ranuan Tarvikekeskus Oy.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { organization, website } from '~/helpers/structuredData'

const config = useRuntimeConfig()

// The front page had no canonical nor structured data (SEO review 22.10.2026)
const baseUrl = config.public.BASE_URL as string
useHead({
  link: [{ rel: 'canonical', href: `${baseUrl}/` }],
  script: [
    { type: 'application/ld+json', children: JSON.stringify(organization(baseUrl)) },
    { type: 'application/ld+json', children: JSON.stringify(website(baseUrl)) }
  ]
})
</script>
